import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getUrlPath } from 'lib/core/resources/helpers'
import { RESOLVER } from 'lib/core/resources/constants'
import { localStorage } from 'lib/core/services/localStorage'
import { useCoreContext } from 'lib/core/hooks'
import { isFetchingSelector } from 'lib/core/data/common/selectors'
import { getCategoryList } from 'lib/core/data/common/categoryList/selectors'
import { getPageList } from 'lib/core/data/common/pageList/selectors'
import { useQuery } from 'react-query'

type Entity = 'category' | 'page' | 'product'

export const usePathResolver = () => {
  const history = useHistory()
  const { magentoClient } = useCoreContext()
  const categoryList = useSelector(getCategoryList)
  const pageList = useSelector(getPageList)
  const slug = getUrlPath(history.location).toLowerCase()
  const isFetching = useSelector(isFetchingSelector)

  const { isLoading, data } = useQuery(['usePathResolver', slug], async () => {
    return magentoClient?.common.urlResolver({ path: slug })
      .then((response) => {
        let entity: Entity | undefined
        let path: string | undefined
        const { id, type, sku, relative_url: relativeUrl } = response?.data?.data?.urlResolver ?? {}

        if (type === RESOLVER.PRODUCT && sku) {
          entity = 'product'
          path = relativeUrl
        }

        if (type === RESOLVER.CATEGORY) {
          const _category = categoryList.id[id]
          if (_category) {
            localStorage.set('latestCategory', _category)
            entity = 'category'
            path = relativeUrl
          }
        }

        if (type === RESOLVER.CMS_PAGE) {
          const _cmsPage = pageList.list.find(_cms => _cms.id === id)
          if (_cmsPage) {
            entity = 'page'
            path = relativeUrl
          }
        }

        if (slug && !entity) { // Fallback version for CMS Pages. BJ was not resolving.
          const _cmsPage = pageList.identifier[slug]
          if (_cmsPage) {
            entity = 'page'
            path = slug
          }
        }

        if (path) {
          const search = history.location.search ?? ''
          const hash = history.location.hash ?? ''
          history.replace(`/${path}${search}${hash}`)
        }

        return {
          entity,
          slug,
          sku
        }
      })
  }, {
    enabled: !isFetching
  })

  return {
    loading: isLoading,
    entity: data?.entity,
    sku: data?.sku,
    slug: slug
  }
}
